export default __webpack_public_path__ + "static/media/card_bg_yiwang.61cbfdac.png";